module.exports = __webpack_public_path__ + "static/media/social_media_scam.31b18a95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/social_media_scam.jpg
// module id = 210
// module chunks = 0